
import coldSnacks from "./coldSnacks";  
import salads from "./salads";
import quicheLorraine from "./quicheLorraine";
import hotDishes from "./hotDishes";
import sideDishes from "./sideDishes";
import fishDishes from "./fishDishes";
import meatDishes from "./meatDishes";
import desserts from "./desserts";
import drinks from "./drinks";

const allDishes = [
    ...coldSnacks,
    ...salads,
    ...quicheLorraine,
    ...hotDishes,
    ...sideDishes,
    ...fishDishes,
    ...meatDishes,
    ...desserts,
    ...drinks
];

export default allDishes;